import { useState, useEffect, useContext, useRef } from 'react';
import { StateContext, DispatchContext } from '../../App';

import './Gallery.css';
import Card from '../Card/Card';
import Loader from '../Loader/Loader';

import cursor from '../../images/icons/icon-plus.svg'

import { 
    dispatchFilterUpdate, 
    dispatchSubheaderTextUpdate,
    dispatchArticlesData ,
    useWindowDimensions
} from '../../functions/functions';

const Gallery = ({ scrollTop }) => {
    const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);
    
    const { filter, production } = appState.appSettings;
    
    const [ data, setData ] = useState();
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ hasError, setError ] = useState(false);
    const [ isIntl, setIsIntl ] = useState(false);
    const [ cardType, setCardType ] = useState('portrait');
    const [ collection, setCollection ] = useState();
    let hasArticle = false;

    const { height } = useWindowDimensions();
    useEffect(() => {
        // FILTER OBJECT AND APIs   :
        // {
        //     init: 'categories', || '.../categories/'
        //     category: 'all',     
        //     collection: '',     || '.../collections?category=sofa'              / '.../collections?category=all'
        //     articles: '',       || '.../articles?category=sofa&collection=eden' / '.../articles?category=all&collection=eden'
        //     article: ''         || '.../article?name='eden002 module'
        // }
        let filterKeys = Object.keys(filter);
        filterKeys.length === 3 ? setCardType('landscape') : setCardType('portrait'); //alternates card orientation: portraite x collections&products gallery, landscape x articles gallery
        let path = ''; //string that will accumulate query params
        switch (filterKeys.length) {
            case 3 : path = 'articles?'; break;
            default : path = 'collections?'; 
        };

        let queryPathAndParams = '';
        filterKeys.forEach(key => {
            if (filter[key] === 'categories') {
                queryPathAndParams = 'categories';
                setIsIntl(true);
            } else {
                path.match(/articles/) ? setIsIntl(true) : setIsIntl(false);
                if (key !== 'init') {
                    if (key === 'article') {
                        hasArticle = true;
                        // let encodedName = encodeURIComponent(filter[key]);
                        // queryPathAndParams = `article?name=${encodedName}`;
                        queryPathAndParams = `articles/${filter[key]}/`;
                    } else {
                        queryPathAndParams = path += `${key}=${filter[key].toLowerCase()}&`
                    };
                } else {
                    queryPathAndParams = 'collections?category=all'
                };
            };
        });

        let regex = /&$/;
        if (queryPathAndParams.match(regex)) {
            let index = queryPathAndParams.match(regex).index
            queryPathAndParams = queryPathAndParams.slice(0,index)
        };
        
        let isMounted = true;
        const getData = async (url) => {
            
            let proxy = production ? '' : 'https://serene-springs-29711.herokuapp.com/';
            setIsLoaded(false);
            await fetch(`${proxy}http://rodabackend.com/mocked_api/v1/${url}/`)
            .then(res => res.json())
            .then(data => {
                if (data !== 'Mocked API not configured') {
                    if (isMounted) {
                        setError(false);
                        if (hasArticle) {
                            // data.hasModules ? dispatch({
                            //     type: 'TOGGLE_HAS_MODULES',
                            //     payload: true
                            // }) : dispatch({
                            //     type: 'TOGGLE_HAS_MODULES',
                            //     payload: false
                            // })
                            let articles = [];
                            data.item_id = data.id; 
                            articles.push(data);
                            dispatchArticlesData(dispatch, articles);
                            dispatch({
                                type: 'TOGGLE_IS_ARTICLE_SELECTED',
                                payload: true
                            });
                            const userArticle = [];
                            userArticle.push({
                                item_id: data.item_id,
                                id: data.id,
                                collection: data.collection,
                                options: undefined
                            });
                            dispatch({
                                type:  'SET_ARTICLES',
                                payload: userArticle
                            });
                        } else {
                            setData(data.items);
                        }; 
                        if (data.design !== undefined) {
                            dispatchSubheaderTextUpdate(dispatch, {
                                info: data.design,
                                title: collection,
                                note: null
                            });
                            dispatch({
                                type: 'SET_DESIGNER',
                                payload: data.design
                            })
                        } 
                        setIsLoaded(true);
                    }
                } else {
                    setError(true)
                }
            })
            .catch(error => {
                console.log(error); 
            }); 
            
        };
         
        getData(queryPathAndParams);
        return () => {
            isMounted = false;
        };
        // setIsMasked(!isMasked);
    }, [filter, production])
    
    const updateFilter = (value) => {
        let currentFiltersLength = Object.keys(filter).length;
        
        if (filter.init === 'collections') {
            if (currentFiltersLength === 3) {
                dispatchFilterUpdate(dispatch, 'article', value);
                
            } else {
                dispatchFilterUpdate(dispatch, 'category', 'all');
                dispatchFilterUpdate(dispatch, 'collection', value);
                setCollection(value);
                dispatch({
                    type: 'SET_COLLECTION_NAME',
                    payload: value
                })
                // dispatchSubheaderTextUpdate(dispatch, {
                //     info: designInfo,
                //     title: value,
                //     note: null
                // });
            };
        } else {
            if (currentFiltersLength === 3) {
                dispatchFilterUpdate(dispatch, 'article', value);
            } else if (currentFiltersLength === 2) {
                dispatchFilterUpdate(dispatch, 'collection', value);
                setCollection(value);
                dispatch({
                    type: 'SET_COLLECTION_NAME',
                    payload: value
                })
                // dispatchSubheaderTextUpdate(dispatch, {
                //     info: designInfo,
                //     title: value,
                //     note: null
                // });
            } else {
                dispatchFilterUpdate(dispatch, 'category', value);
                dispatchSubheaderTextUpdate(dispatch, {
                    info: null,
                    title: value,
                    note: null
                });
            }
        };
    };

    let iniCursorStyle = {
        width:'50px', 
        height:'50px', 
        position: 'absolute',
        mixBlendMode: 'difference',
        pointerEvents: 'none',
        transform: 'translate3d()',
        zIndex: 3
    };

    const [ isCursorOn, setIsCursorOn ] = useState(false);
    const [ cursorStyle, setCursorStyle ] = useState();
    
    const toggleCursor = (cursor) => {
        if (cursor) {
            document.getElementById('glr').style.cursor = 'none';
            setIsCursorOn(true);
        } else {
            document.getElementById('glr').style.cursor = 'auto';
            setIsCursorOn(false);
        };
    };

    const moveCursor = (e) => {
        let x = e.clientX;
        let y = scrollTop + e.clientY;
        let newposX = x - 55;
        let newposY = y - 235; 
        setCursorStyle({...iniCursorStyle, transform: `translate(${newposX}px, ${newposY}px)`});
    };

    return (
        <div 
            className='gallery' 
            id='glr' 
            onMouseMove={(e) => moveCursor(e)}
        >
            <div id='cursor' style={isCursorOn ? cursorStyle : {opacity: '0', transition: 'opacity .2s'}} >
                <img src={cursor} alt='cursor'/>
            </div>
            {
                hasError ? null : isLoaded ? data.map((item, _i) => {
                    return (
                        <Card
                            key={item.id ? item.id : _i}
                            id={item.id ? item.id : 0}
                            cardType={cardType}
                            name={item.name}
                            imgUrl={item.imgUrl}
                            updateFilter={updateFilter}
                            toggleCursor={toggleCursor}
                        />
                    )
                }) : <Loader 
                    height={height - 150}
                    isLoaded={isLoaded}
                />
            }
        </div>
    )
};
export default Gallery;

